"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornVerticalNavigationGroup = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcornVerticalNavigationItem_1 = require("./AcornVerticalNavigationItem");
var authentication_1 = require("../authentication");
var AcornVerticalNavigationGroup = function (props) {
    var history = react_router_dom_1.useHistory();
    var groupActive = props.children.some(function (child) { return child.path === history.location.pathname || history.location.pathname.indexOf(child.path) === 0; });
    return (react_1.default.createElement("li", { className: 'c-nav__item' + (groupActive ? ' +active' : '') },
        react_1.default.createElement(react_router_dom_1.Link, { className: "c-nav__item-top-level", to: props.path },
            props.icon && (react_1.default.createElement("svg", { className: "c-icon " },
                react_1.default.createElement("use", { href: '/symbol-defs.svg#icon-' + props.icon }))),
            react_1.default.createElement("span", { className: "c-nav__item-link-text" }, props.name),
            react_1.default.createElement("svg", { className: "c-icon " },
                react_1.default.createElement("use", { href: "/symbol-defs.svg#icon-keyboard_arrow_down" }))),
        react_1.default.createElement("ul", { className: "c-nav +secondary" }, props.children.map(function (child) {
            var active = child.path === history.location.pathname;
            var item = (react_1.default.createElement(AcornVerticalNavigationItem_1.AcornVerticalNavigationItem, { key: child.name, name: child.name, path: child.path, active: active }));
            if (child.requiredPermissions && child.requiredPermissions.length > 0) {
                return (react_1.default.createElement(authentication_1.GuardedContainer, { requiredPermissions: child.requiredPermissions }, item));
            }
            else {
                return item;
            }
        }))));
};
exports.AcornVerticalNavigationGroup = AcornVerticalNavigationGroup;
//# sourceMappingURL=AcornVerticalNavigationGroup.js.map